// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Participant {
	//
}
export default Participant
